/**
=========================================================
* BASE: Learning Repository - v1.0.0
=========================================================

* Copyright 2022 Sean Dooley (https://www.dooley-dev.com)

Coded by www.dooley-dev.com

 =========================================================

* The above copyright notice shall be included in substantial portions of the Software.
*/
import React, { useState, useMemo } from "react";

const useGroupedListing = (data, groupByKey, searchKeys) => {
  // Initialize search term state
  const [searchTerm, setSearchTerm] = useState('');

  const groupedData = useMemo(() => {
    // First, filter data based on the search term across the specified search keys
    const filteredData = data.filter(item =>
      searchKeys.some(key =>
        item[key]?.toString().toLowerCase().includes(searchTerm.toLowerCase())
      )
    );

    // Group the filtered data by the specified groupByKey
    return filteredData.reduce((acc, item) => {
      const groupKey = item[groupByKey]?.charAt(0).toUpperCase() || '#'; // Default to '#' if no group key
      if (!acc[groupKey]) {
        acc[groupKey] = [];
      }
      acc[groupKey].push(item);
      return acc;
    }, {});
  }, [data, searchTerm, groupByKey, searchKeys]);

  return { groupedData, searchTerm, setSearchTerm };
};

export default useGroupedListing;